import { render, staticRenderFns } from "./VisaHome.vue?vue&type=template&id=d8a40ef0&scoped=true&"
import script from "./VisaHome.vue?vue&type=script&lang=js&"
export * from "./VisaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a40ef0",
  null
  
)

export default component.exports